import { App } from 'antd';

type MessageApi = ReturnType<typeof App.useApp>['message'];

let api: MessageApi | undefined;

export function registerMessageApi(instance: MessageApi) {
  api = instance;
}

export const message: MessageApi = new Proxy({} as MessageApi, {
  get(_target, prop) {
    return (...args: unknown[]) =>
      (api as Record<string, (...a: unknown[]) => unknown> | undefined)?.[prop as string]?.(...args);
  },
});
